"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var delay_exports = {};
__export(delay_exports, {
  DelayStrategyFactory: () => DelayStrategyFactory,
  ExponentialBackoffStrategy: () => ExponentialBackoffStrategy,
  FibonacciDelayStrategy: () => FibonacciDelayStrategy,
  FixedDelayStrategy: () => FixedDelayStrategy,
  sleep: () => sleep
});
module.exports = __toCommonJS(delay_exports);
const DelayStrategyFactory = {
  /**
   * Create a fixed delay strategy
   */
  fixed(options) {
    return new FixedDelayStrategy(options);
  },
  /**
   * Create an exponential backoff delay strategy
   */
  exponentialBackoff(options) {
    return new ExponentialBackoffStrategy(options);
  },
  /**
   * Create a Fibonacci delay strategy
   */
  fibonacci(options) {
    return new FibonacciDelayStrategy(options);
  }
};
class FixedDelayStrategy {
  static {
    __name(this, "FixedDelayStrategy");
  }
  delayMs;
  jitter;
  constructor(options) {
    this.delayMs = options.delayMs;
    this.jitter = options.jitter ?? 0;
  }
  getDelay(_attempt) {
    if (this.jitter > 0) {
      const jitterAmount = this.delayMs * this.jitter * (Math.random() * 2 - 1);
      return Math.max(0, this.delayMs + jitterAmount);
    }
    return this.delayMs;
  }
}
class ExponentialBackoffStrategy {
  static {
    __name(this, "ExponentialBackoffStrategy");
  }
  initialDelayMs;
  maxDelayMs;
  backoffFactor;
  jitter;
  constructor(options) {
    this.initialDelayMs = options.initialDelayMs;
    this.maxDelayMs = options.maxDelayMs;
    this.backoffFactor = options.backoffFactor;
    this.jitter = options.jitter ?? 0;
  }
  getDelay(attempt) {
    const baseDelay = Math.min(this.initialDelayMs * Math.pow(this.backoffFactor, attempt - 1), this.maxDelayMs);
    if (this.jitter > 0) {
      const jitterAmount = baseDelay * this.jitter * (Math.random() * 2 - 1);
      return Math.min(Math.max(0, baseDelay + jitterAmount), this.maxDelayMs);
    }
    return baseDelay;
  }
}
class FibonacciDelayStrategy {
  static {
    __name(this, "FibonacciDelayStrategy");
  }
  baseDelayMs;
  maxDelayMs;
  jitter;
  // Cache for Fibonacci numbers to improve performance
  fibCache;
  constructor(options) {
    this.baseDelayMs = options.baseDelayMs;
    this.maxDelayMs = options.maxDelayMs;
    this.jitter = options.jitter ?? 0;
    this.fibCache = /* @__PURE__ */ new Map([
      [0, 0],
      [1, 1]
    ]);
  }
  fibonacci(n) {
    if (this.fibCache.has(n)) {
      return this.fibCache.get(n);
    }
    if (n <= 1) {
      return n;
    }
    const result = this.fibonacci(n - 1) + this.fibonacci(n - 2);
    this.fibCache.set(n, result);
    return result;
  }
  getDelay(attempt) {
    const fibNumber = this.fibonacci(attempt + 1);
    const baseDelay = Math.min(fibNumber * this.baseDelayMs, this.maxDelayMs);
    if (this.jitter > 0) {
      const jitterAmount = baseDelay * this.jitter * (Math.random() * 2 - 1);
      return Math.min(Math.max(0, baseDelay + jitterAmount), this.maxDelayMs);
    }
    return baseDelay;
  }
}
function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
__name(sleep, "sleep");
//# sourceMappingURL=delay.js.map
